import { useEffect } from 'react';
import { useScriptHead, type ScriptStatus } from './useScriptHead';

declare global {
  interface Window {
    Osano?: {
      cm: {
        showDrawer: (id: string) => void;
      };
    };
  }
}

type Props = {
  src: string;
  visible: boolean;
};

export function useOsanoScript({ src, visible }: Props): ScriptStatus {
  const scriptStatus = useScriptHead({ id: 'osano', src });

  useEffect(() => {
    let pollInterval: ReturnType<typeof setInterval> | null = null;
    let attempts = 0;
    const maxAttempts = 20;

    const updateWidgetVisibility = (): boolean => {
      const osanoWidgetElement = document.querySelector<HTMLElement>('.osano-cm-window__widget');

      if (!osanoWidgetElement) {
        if (attempts < maxAttempts) {
          attempts++;
          return false;
        }
        return true;
      }

      osanoWidgetElement.style.display = visible ? 'block' : 'none';
      return true;
    };

    const shouldStop = updateWidgetVisibility();

    if (!shouldStop) {
      pollInterval = setInterval(() => {
        if (updateWidgetVisibility()) {
          if (pollInterval) {
            clearInterval(pollInterval);
            pollInterval = null;
          }
        }
      }, 100);
    }

    return () => {
      if (pollInterval) {
        clearInterval(pollInterval);
      }
    };
  }, [visible, scriptStatus]);

  return scriptStatus;
}
